<script>
    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            permission() {return this.$store.getters.CONST_PERMISSIONS},
            roleEditData() {return this.$store.getters.ROLE_EDIT_DATA},
        },
        methods: {
            async changeName(event) {
                const value = event.target.value;
                this.$store.commit('ROLE_EDIT_UPDATE', {
                    fieldName: 'name', fieldValue: value
                });
                this.errorText = await this.$store.dispatch('CHECK_ROLE_EDIT');
            },
            async changeCheckbox(event) {
                const target = event.target;
                this.$store.commit('ROLE_EDIT_UPDATE', {
                    fieldName: target.value,
                    fieldValue: target.checked
                });
                this.errorText = await this.$store.dispatch('CHECK_ROLE_EDIT');
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input
            @change="changeName"
            :value="roleEditData['name']"
            class="right_input mt_5 mb_10"
            type="text"
        >
        <Label>Permissions:</Label>
        <ul class="ul_2_columns mt_5">
            <li
                v-for="(permissionValue, permissionIndex) in permission" :key="permissionIndex"
            >
                <label>
                    <input 
                        :checked="roleEditData[permissionValue['id']]"
                        type="checkbox"
                        @change="changeCheckbox"
                        :value="permissionValue['id']"
                    >
                    {{ permissionValue['name'] }}
                </label>
            </li>
        </ul>

        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>